// eslint-disable-next-line no-useless-escape
const EMAIL_PATTERN = /^[a-zA-Z0-9_\-\+'`\?=\*%\$#!/^\{\|}~\.]+@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9]+)$/;

export const isEmail = (inputValue: string) => {
	let valid = false;

	// limit the number of matches required by a complicated regex, and make it simple, with some full stop checks
	// for good measure, to be certain we should be dealing with a valid looking email address.
	// this mirrors the approach in EmailUtil.java
	if (EMAIL_PATTERN.test(inputValue)) {
		const name = inputValue.split('@')[0].trim();
		valid = !name.startsWith('.') && !name.endsWith('.') && !name.includes('..');
	}

	return valid;
};
